// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Lzy from "../util/Lzy.bs.js";
import * as Data9 from "./Data9.bs.js";
import * as Js_exn from "rescript/lib/es6/js_exn.js";
import * as Js_dict from "rescript/lib/es6/js_dict.js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as Belt_MapInt from "rescript/lib/es6/belt_MapInt.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as Belt_MapString from "rescript/lib/es6/belt_MapString.js";

var all = [
  "TFT9_Cassiopeia",
  "TFT9_ChoGath",
  "TFT9_Irelia",
  "TFT9_Jhin",
  "TFT9_Kayle",
  "TFT9_Malzahar",
  "TFT9_Maokai",
  "TFT9_Orianna",
  "TFT9_Poppy",
  "TFT9_Renekton",
  "TFT9_Samira",
  "TFT9_Tristana",
  "TFT9_Viego",
  "TFT9_Ashe",
  "TFT9_Galio",
  "TFT9_Jinx",
  "TFT9_Kassadin",
  "TFT9_Kled",
  "TFT9_Sett",
  "TFT9_Soraka",
  "TFT9_Swain",
  "TFT9_Taliyah",
  "TFT9_Teemo",
  "TFT9_Vi",
  "TFT9_Warwick",
  "TFT9_Zed",
  "TFT9_Akshan",
  "TFT9_Darius",
  "TFT9_Ekko",
  "TFT9_Garen",
  "TFT9_Jayce",
  "TFT9_Kalista",
  "TFT9_Karma",
  "TFT9_Katarina",
  "TFT9_Lissandra",
  "TFT9_RekSai",
  "TFT9_Sona",
  "TFT9_Taric",
  "TFT9_VelKoz",
  "TFT9_Aphelios",
  "TFT9_Azir",
  "TFT9_Gwen",
  "TFT9_JarvanIV",
  "TFT9_KaiSa",
  "TFT9_Lux",
  "TFT9_Nasus",
  "TFT9_Sejuani",
  "TFT9_Shen",
  "TFT9_Urgot",
  "TFT9_Yasuo",
  "TFT9_Zeri",
  "TFT9_Aatrox",
  "TFT9_Ahri",
  "TFT9_BelVeth",
  "TFT9_Heimerdinger",
  "TFT9_KSante",
  "TFT9_Ryze",
  "TFT9_Senna",
  "TFT9_Sion"
];

var ryzes = [
  "TFT9_RyzeBandleCity",
  "TFT9_RyzeDemacia",
  "TFT9_RyzeFreljord",
  "TFT9_RyzeIonia",
  "TFT9_RyzeNoxus",
  "TFT9_RyzePiltover",
  "TFT9_RyzeShadowIsles",
  "TFT9_RyzeShurima",
  "TFT9_RyzeTargon",
  "TFT9_RyzeZaun"
];

function toId(t) {
  return all.indexOf(t);
}

function fromId(idx) {
  return Belt_Array.getExn(all, idx);
}

function toApiName(prim) {
  return prim;
}

function fromApiNameSafe(v) {
  if (all.includes(v) || ryzes.includes(v)) {
    return v;
  }
  
}

function fromApiName(apiName) {
  var v = fromApiNameSafe(apiName);
  if (v !== undefined) {
    return v;
  } else {
    return Js_exn.raiseError("Unknown api name " + apiName);
  }
}

function toName(t) {
  return Belt_Array.getExn(t.split("_"), 1);
}

var urlNameMap = Lzy.make(function (param) {
      var base = Belt_Array.map(Belt_Array.concat(all, ryzes), (function (u) {
              return [
                      u,
                      Belt_Array.getExn(u.split("_"), 1).toLowerCase()
                    ];
            }));
      var map = Belt_MapInt.fromArray(base);
      var revMap = Belt_MapString.fromArray(Belt_Array.map(base, (function (param) {
                  return [
                          param[1],
                          param[0]
                        ];
                })));
      return [
              map,
              revMap
            ];
    });

function toUrlName(t) {
  var match = Lzy.get(urlNameMap);
  return Belt_Option.getExn(Belt_MapInt.get(match[0], t));
}

function fromUrlName(name) {
  var match = Lzy.get(urlNameMap);
  return Belt_MapString.get(match[1], name);
}

function getInfo(t) {
  return Belt_Option.getExn(Js_dict.get(Data9.units, t));
}

export {
  all ,
  ryzes ,
  toId ,
  fromId ,
  toApiName ,
  fromApiNameSafe ,
  fromApiName ,
  toName ,
  urlNameMap ,
  toUrlName ,
  fromUrlName ,
  getInfo ,
  
}
/* urlNameMap Not a pure module */
